import React from 'react';

export const formatContactData = ({
  companyName = '',
  personName = '',
  ext = '',
  email = '',
  firstName = '',
  lastName = '',
  phoneNumber = '',
  countryCode = '',
} = {}) => ({
  companyName,
  personName,
  ext,
  name: `${firstName} ${lastName}`,
  phoneNumber,
  email,
  countryCode,
});

export const oneLine = (str, ...tailVariables) =>
  str
    .map(
      (item, index) =>
        `${item.replace(/\n/g, ' ')}${tailVariables[index] || ''}`,
    )
    .toString();

const ExternalLink = ({ url, text }) => (
  <a className="color-persian-red" href={url} target="_blank" rel="noreferrer">
    {text}
  </a>
);

export const replaceWithLink = (str, ...tailVariables) =>
  str.reduce((accumulator, currentValue, index) => (
    <div>
      {accumulator}
      <ExternalLink
        url={tailVariables[index - 1]}
        text="Letter of Authorization template"
      />
      {currentValue}
    </div>
  ));

export const formatContactMedicalWasteManager = ({
  companyName = '',
  personName = '',
  email = '',
  phoneNumber = '',
  countryCode = '',
} = {}) => ({
  companyName,
  personName,
  phoneNumber,
  email,
  countryCode,
});

export function formatStringWithLineSeparators(string) {
  return string
    .replace(/(?:\r\n|\r|\n)/g, '<br>')
    .replace(/<(\/)?script>/gi, '&lt;script&gt;');
}

/**
 * Sanitizes and joins array and sanitaze
 * @param {*} arr Array you want to join
 * @returns {string} Markup, separated with <br>
 */
export function joinArrayWithLineSeparators(arr) {
  return arr
    .join('<br class="mb-1">')
    .replace(/<(\/)?script>/gi, '&lt;script&gt;');
}

/**
 * Formats number the way you want to
 * @param {number} amount Number
 * @param {number} [decimalCount = 2] Quantity of decimals
 * @param {string} [decimal = '.'] Decimal separator
 * @param {string} [thousands = '.'] Thousands separator
 * @returns {string} Desired string
 * @example
 *  formatNumber(6666101, 2)
 * @deprecated
 */
export const formatNumber = (
  amount,
  decimalCount = 2,
  decimal = '.',
  thousands = ',',
) => {
  let newDecimalCount;
  let newAmount;
  newDecimalCount = Math.abs(decimalCount);
  newDecimalCount = isNaN(decimalCount) ? 2 : decimalCount;

  const negativeSign = amount < 0 ? '-' : '';

  const i = parseInt(
    (newAmount = Math.abs(Number(amount) || 0).toFixed(newDecimalCount)),
    10,
  ).toString();
  const j = i.length > 3 ? i.length % 3 : 0;

  return (
    negativeSign +
    (j ? i.substr(0, j) + thousands : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${thousands}`) +
    (newDecimalCount
      ? decimal +
        Math.abs(newAmount - i)
          .toFixed(newDecimalCount)
          .slice(2)
      : '')
  );
};

export const checkDefaultCountryOnlyInObject = (
  firstObj = {},
  secondObj = {},
) => {
  const newArr = [
    ...new Set([
      ...Object.getOwnPropertyNames(firstObj),
      ...Object.getOwnPropertyNames(secondObj),
    ]),
  ];

  if (newArr.length === 1 && newArr.includes('countryCode')) {
    return true;
  }

  return false;
};
